import { clsx } from 'clsx'

import { AITitle } from './assets/AITitle'
import { BufferLogo } from './assets/BufferLogo'
import { Star } from './assets/Star'
import { Wand } from './assets/Wand'
import styles from './WelcomeAnimation.module.css'

import type { JSX } from 'react'

export function WelcomeAnimation({
  beginTransition,
}: {
  beginTransition: boolean
}): JSX.Element {
  return (
    <div
      className={clsx(styles.outerWrapper, beginTransition && styles.fadeOut)}
    >
      <div className={styles.logoWrapper}>
        <BufferLogo />
      </div>
      <div className={styles.titleWrapper}>
        <div className={styles.aiTitleWrapper}>
          <div className={styles.wandGroupWrapper}>
            <Star className="star1" />
            <Star className="star2" />
            <Star className="star3" />
            <Wand />
          </div>
          <AITitle />
        </div>
      </div>
      <div className={styles.gradientBackground} />
    </div>
  )
}
